import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import { StyleProps } from '..';

const TitleInput: React.FC<
  StyleProps &
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = ({ className, children, ...props }) => {
  return (
    <input
      className={`header-title transition-opacity ${className}`}
      css={css`
        ${tw`
          block
          rounded-none
          w-full
          resize-none
          overflow-auto
          border-b-2
          border-transparent
          border-dashed
          focus:outline-none
          px-0
          py-0
          opacity-100
          mb-0
          `}
          ${css`
            line-height: 1em;
            margin-left: 0.2rem;
          `}
          &:not([disabled]) {
          ${tw`
            opacity-60
            hover:opacity-80
            hover:border-gray-400
            focus:opacity-100
            focus:border-gray-400
            focus:border-solid
          `}
          &::placeholder {
            opacity: 1;
            ${tw`text-color-input-placeholder`}
          }
        `}
      {...props}
    >
      {children}
    </input>
  );
};

export default TitleInput;
